function ContentContainer({ children }) {
  return <div className="content-x py-8 lg:pb-24 lg:pt-12">{children}</div>;
}

function ContentTitle({ children }) {
  return <h1 className="mb-8 text-5xl font-bold">{children}</h1>;
}

export { ContentContainer, ContentTitle };
